export const FUNCTIONALITIES_ENDPOINTS = {
    functionalities: '/functionalities/me',
};
